import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import AggregatorService from '../../../CheckoutAdditionalService/CheckoutAdditionalService/Aggregator/AggregatorService';
import Button from '../../../BaseComponents/Button';
import Money from '../../../Money';
import { CardExtraIcon } from '@shared/ui';
import { SafeHtml } from '@shared/ui';
const CardExtraContent = ({ type, insuranceCodes, variant, icon, aggregationIcons, coverClassName, content, additionalControls, title, description, style, options, minPrice, totalPrice, isSelected, isConfirmed, isLoading, onChangeService, onToggleService, onViewLoyaltyStatus, hideFooterControls, additionalFooterControls, additionalText }) => {
    const { t } = useTranslation('CardExtra');
    const { CardExtraContent: theme } = useTheme('CardExtra');
    const serviceTitle = title !== null && title !== void 0 ? title : t(`ServiceTitle.${type}`);
    const serviceDescription = description !== null && description !== void 0 ? description : t(`ServiceDescription.${type}`);
    const buttonClasses = cn(theme.button, {
        [theme.button_add]: !isSelected,
        [theme.button_change]: isSelected
    });
    const buttonText = useMemo(() => {
        if (!isSelected) {
            return t('Add');
        }
        if (isConfirmed) {
            return t('More details');
        }
        return t(onToggleService ? 'Remove' : 'Edit');
    }, [isSelected, isConfirmed, onToggleService]);
    const onClickButton = onToggleService !== null && onToggleService !== void 0 ? onToggleService : onChangeService;
    if (variant === 'aggregator') {
        const { Loyalty: loyaltyTheme } = useTheme('CheckoutAdditionalService');
        const isLoyaltySelected = type === 'loyalty' && isSelected;
        const aggregatorButtonAction = isLoyaltySelected && onViewLoyaltyStatus ? onViewLoyaltyStatus : onClickButton;
        const aggregatorButtonText = isLoyaltySelected ? t('View status') : buttonText;
        return (React.createElement(AggregatorService, { className: cn(theme.root, theme.root_aggregator, loyaltyTheme.loyalty), header: serviceTitle, description: serviceDescription, coverBackgroundUrl: icon, coverBackgroundColor: style === null || style === void 0 ? void 0 : style.headerBg, coverClassName: coverClassName, aggregationIcons: aggregationIcons, displayOrder: style === null || style === void 0 ? void 0 : style.displayOrder, buttons: [{ text: aggregatorButtonText, action: aggregatorButtonAction, isLoading }], hideFooterButtons: hideFooterControls, isSelected: isSelected, isLoading: isLoading, addClick: aggregatorButtonAction }, content));
    }
    return (React.createElement("div", { className: cn(theme.root, {
            [theme.selected]: isSelected,
            [theme.root_seats]: type === 'seats',
            [theme.root_baggage]: type === 'baggage',
            [theme.root_baggageDelivery]: type === 'baggage-delivery',
            [theme.root_animal]: type === 'animal',
            [theme.root_meal]: type === 'meal',
            [theme.root_businessLounge]: type === 'business-lounge',
            [theme.root_priorityBoarding]: type === 'priority-boarding',
            [theme.root_insurance]: type === 'insurance',
            [theme.root_transfer]: type === 'transfer',
            [theme.root_capsuleHotel]: type === 'capsule-hotel',
            [theme.root_loyalty]: type === 'loyalty',
            [theme.root_upgrade]: type === 'upgrade',
            [theme.root_sms]: type === 'sms',
            [theme.root_refundableTicket]: type === 'refundable-ticket',
            [theme.root_misc]: type === 'misc'
        }), "data-service-type": type, "data-insurance-code": insuranceCodes === null || insuranceCodes === void 0 ? void 0 : insuranceCodes[0], style: { order: style === null || style === void 0 ? void 0 : style.displayOrder } },
        React.createElement("div", { className: theme.header, style: { background: style === null || style === void 0 ? void 0 : style.headerBg } },
            React.createElement("div", { className: theme.header__title }, serviceTitle),
            React.createElement("div", { className: cn(theme.header__icon, { [theme.loyalty__icon]: type === 'loyalty' }) },
                React.createElement(CardExtraIcon, { type: type, iconUrl: icon }))),
        React.createElement("div", { className: theme.content },
            content,
            !isSelected && (React.createElement("div", { className: theme.description, dangerouslySetInnerHTML: { __html: serviceDescription } })),
            !!additionalText && (React.createElement("div", { className: theme.additionalText, dangerouslySetInnerHTML: { __html: additionalText } })),
            !!(options === null || options === void 0 ? void 0 : options.length) &&
                options.map((option, index) => (React.createElement(SafeHtml, { key: index, tag: "div", className: theme.options, html: option })))),
        additionalControls && React.createElement("div", { className: theme.controls }, additionalControls),
        React.createElement("div", { className: theme.footer },
            type !== 'loyalty' && (React.createElement("span", { className: theme.footer__price }, isSelected
                ? (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.amount) > 0 && (React.createElement("span", null,
                    t('total'),
                    ":",
                    React.createElement(Money, { money: totalPrice })))
                : minPrice && (React.createElement("span", null,
                    t('from'),
                    React.createElement(Money, { money: minPrice }))))),
            !hideFooterControls &&
                (type === 'loyalty' ? (onViewLoyaltyStatus && (React.createElement(Button, { className: buttonClasses, variant: isSelected ? 'text' : 'optionAction', onClick: isSelected ? onViewLoyaltyStatus : onChangeService, isLoading: isLoading }, t(isSelected ? 'View status' : 'Register')))) : (React.createElement(Button, { className: buttonClasses, variant: isSelected ? 'optionEdit' : 'optionAction', onClick: onClickButton, isLoading: isLoading }, buttonText))),
            additionalFooterControls)));
};
export default CardExtraContent;
